// A body is sent once; after a failure it goes again only on a further edit or a flush.
export const shouldSchedule = (key: string, sentKey: string): boolean => key !== sentKey;

export const shouldFlush = (key: string, sentKey: string, failedKey: string | null): boolean =>
    key !== sentKey || key === failedKey;
